export const companiesAreaCompanyTabPathName = '';
export const companiesAreaCompanyTabLabel = 'Virksomheder';
export const companiesAreaTasksTabPathName = 'tasks';
export const companiesAreaTasksTabLabel = 'Opgaver';
export const companiesAreaContactPersonsTabLabel = 'Virksomhedskontaktpersoner';
export const companiesAreaLookupAccountTabLabel = 'Virksomhedsopslag';
export const companiesAreaAppointmentsTabLabel = 'Virksomhedsaftaler';
export const companiesAreaAppointmentsTabPathName = 'appointments';
